import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ClaimsService } from "src/app/core/services/claims.service";
import { PublicService } from "src/app/core/services/public.service";
import { RegistrationService } from "src/app/core/services/registration.service";
import Swal from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: "app-finnova-payments",
  templateUrl: "./finnova-payments.component.html",
  styleUrls: ["./finnova-payments.component.scss"],
})
export class FinnovaPaymentsComponent implements OnInit {
  relationshipType: any;
  treatmentSubtypeOptions: any = [];
  states: any;
  cities: any;
  selectedState: any;
  constructor(
    private claimsService: ClaimsService,
    private registrationService: RegistrationService,
     private router: Router,
  ) {}
  claimForm = new FormGroup({
    claimNumber: new FormControl("", [Validators.required]),
    dateOfAdmission: new FormControl("", [Validators.required]),
    dateOfDischarge: new FormControl("", [Validators.required]),
    claimedAmount: new FormControl("", [Validators.required]),
    approvedAmount: new FormControl("", [Validators.required]),
    tpaName: new FormControl("", [Validators.required]),
    patientFirstName: new FormControl("", [Validators.required]),
    patientLastName: new FormControl("", [Validators.required]),
    patientMobile: new FormControl("", [Validators.required]),
    patientType: new FormControl("self", [Validators.required]),
    treatmentType: new FormControl("", [Validators.required]),
    treatmentSubtype: new FormControl("", [Validators.required]),
    firstName: new FormControl("", [Validators.required]),
    middleName: new FormControl(""),
    lastName: new FormControl("", [Validators.required]),
    mobileNumber: new FormControl("", [Validators.required]),
    email: new FormControl("", [Validators.required,Validators.email ]),
    gender: new FormControl("", [Validators.required]),
    dob: new FormControl("", [Validators.required]),
    panNumber: new FormControl("", [Validators.required]),
    addressLine1: new FormControl("", [Validators.required]),
    addressLine2: new FormControl(""),
    pincode: new FormControl("", [Validators.required]),
    city: new FormControl("", [Validators.required]),
    state: new FormControl("", [Validators.required]),
    employmentType: new FormControl("", [Validators.required]),
    monthlyIncome: new FormControl("", [Validators.required]),
    officePincode: new FormControl("", [Validators.required]),
    orderAmount: new FormControl("", [Validators.required]),
    relationshipWithPatient: new FormControl(""),
  });
  ngOnInit(): void {
    this.getClaimDetailsList(0, 10, "REJECTIONS_RECIEVED");
    this.getAllTPA();
    this.getAllStatus();
    this.getStates();
  }

  view: any = "new";
  list: any;
  selected: any = "REJECTIONS_RECIEVED";
  claimSummary: any;
  displayedColumns: string[] = [
    "claimId",
    "memberId",
    "type",
    "memberName",
    "patientId",
    "payer",
    "TPAName",
    "claimStatus",
    "tat",
    "action",
  ];
  dataSource = new MatTableDataSource<any>();
  resultsLength = 0;
  isLoadingResults = true;
  tpaList: any;
  statusList: any;
  claimList = [];
  newClaimListData: any;
  selectedStatus = "";
  newSelectedStatus = "";
  selectedTPA = "";
  onFirstGroupChange(value: any) {
    console.log(value);
  }
  hasCA(data: any): boolean {
    let claimId = data.claimId ? data.claimId : data.id;
    let type = claimId.split("/")[1];
    return type === "CA";
  }
  hasNoTCA(data: any): boolean {
    let claimId = data.claimId ? data.claimId : data.id;
    let type = claimId.split("/")[1];
    return type !== "CA";
  }

  getAllTPA() {
    this.claimsService.getAllTPA().subscribe((data: any) => {
      this.tpaList = data.body;
    });
  }

  sendForFinovaIngestion(claimId: any) {
    Swal.showLoading();
    const submitData = {
      claimId: claimId,
    };
    this.claimsService.sendForFinovaIngestion(submitData).subscribe(
      (data: any) => {
        Swal.close();
        window.open(data.body.redirectUrl, "_blank");
      },
      (error) => {
        Swal.close();
        Swal.fire(error, "", "error");
      }
    );
  }

  getAllStatus() {
    this.claimsService.getAllStatus(this.selected).subscribe((data: any) => {
      this.statusList = data.body?.statusName;
    });
  }

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource<any>(this.claimList);
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterType(event: any) {
    this.dataSource = new MatTableDataSource<any>(this.claimList);
    this.dataSource.filter = event.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getClaimDetailsList(page: any, size: any, status: string) {
    // Swal.showLoading();
    if (this.selectedStatus == "CLAIM_CANCELLED_BY_TPA") {
      this.newSelectedStatus = "CLAIM_REJECTED";
    } else if (this.selectedStatus == "CLAIM_CANCELLED_BY_PROVIDER") {
      this.newSelectedStatus = "CLAIM_REJECTED";
    } else {
      this.newSelectedStatus = this.selectedStatus;
    }
    this.claimsService
      .getClaimDetailsList(
        page,
        size,
        status,
        this.selectedTPA,
        this.newSelectedStatus
      )
      .subscribe(
        (data: any) => {
          this.claimList = data.body;
          this.newClaimListData = data.body;
          Swal.close();
          if (this.newSelectedStatus == "CLAIM_REJECTED") {
            let newClaimList = [];
            for (let j = 0; j < this.newClaimListData.length; j++) {
              if (
                this.newClaimListData[j].claimSubReason == "Cancel Claim" &&
                this.newClaimListData[j].claimRejectedBy == "PROVIDER" &&
                this.selectedStatus == "CLAIM_CANCELLED_BY_PROVIDER"
              ) {
                newClaimList.push(this.newClaimListData[j]);
              }
              if (
                this.newClaimListData[j].claimSubReason == "Cancel Claim" &&
                this.newClaimListData[j].claimRejectedBy == null &&
                this.selectedStatus == "CLAIM_CANCELLED_BY_TPA"
              ) {
                newClaimList.push(this.newClaimListData[j]);
              }
              if (
                this.newClaimListData[j].claimSubReason == null &&
                this.newClaimListData[j].claimRejectedBy == null &&
                this.selectedStatus == "CLAIM_REJECTED"
              ) {
                newClaimList.push(this.newClaimListData[j]);
              }
            }
            this.dataSource = new MatTableDataSource<any>(newClaimList);
            this.dataSource.paginator = this.paginator;
            this.isLoadingResults = false;
          } else {
            this.dataSource = new MatTableDataSource<any>(data.body);
            // this.resultsLength = data.body.length;
            this.isLoadingResults = false;
          }
          if (this.claimSummary) {
            if (this.selected == "ON_GOING") {
              this.resultsLength = this.claimSummary[0].count;
            } else if (this.selected == "APPROVAL_RECIEVED") {
              this.resultsLength = this.claimSummary[1].count;
            } else if (this.selected == "REJECTIONS_RECIEVED") {
              this.resultsLength = this.claimSummary[2].count;
            } else if (this.selected == "SAVED_CLAIMS") {
              this.resultsLength = this.claimSummary[3].count;
            }
          }
        },
        (error) => {
          Swal.close();
        }
      );
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  pageSize: number = 10;
  selectedType: any = "";
  onPageChange(event: PageEvent) {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    this.getClaimDetailsList(pageIndex, pageSize, this.selected);
  }

  checkDoD() {
    if (this.claimForm.controls["dateOfAdmission"].value) {
      return false;
    } else {
      return true;
    }
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onRadioChange(event: any) {
    this.relationshipType = event.value;
    if(this.relationshipType == 'others'){
      this.claimForm.controls['relationshipWithPatient'].setValidators([Validators.required]);
    }else{
      this.claimForm.controls['relationshipWithPatient'].setValidators(null);
    }    
    this.claimForm.updateValueAndValidity();
  }

  submitForm() {
    let data = this.claimForm.value;
    data.state = this.selectedState;
    Swal.showLoading();
    this.claimsService
      .sendLendingOtherClaims(this.claimForm.value)
      .subscribe((res: any) => {
        Swal.close();
        Swal.fire('', res.body.statusMessage, 'success').then(() => {
          window.open(res.body.redirectUrl, "_blank");
          this.router.navigate(['/home']);
        });        
      });
  }

  onSelectionChange(event: any) {
    if (event.value == "Critical Illness") {
      this.treatmentSubtypeOptions = [
        {
          name: "Serviceable for Co-Applicant",
          value: "serviceableForCoApplicant",
        },
        { name: "Heart Attack", value: "heartAttack" },
        { name: "Stroke", value: "stroke" },
        { name: "Kidney Failure", value: "kidneyFailure" },
        { name: "Multiple Sclerosis", value: "multipleSclerosis" },
        { name: "Parkinson Disease", value: "parkinsonsDisease" },
        { name: "Alzheimer’s Disease", value: "alzheimersDisease" },
        { name: "Paralysis", value: "paralysis" },
        { name: "Muscular Dystrophy", value: "muscularDystrophy" },
        { name: "Cardiomyopathy", value: "cardiomyopathy" },
        { name: "Loss of Speech", value: "lossOfSpeech" },
        { name: "Chronic Aplastic Anemia", value: "chronicAplasticAnemia" },
        { name: "Organ Transplants (All Types)", value: "organTransplants" },
        { name: "Hepatitis", value: "hepatitis" },
        {
          name: "Coronary Artery, By-Pass Surgery Disease",
          value: "coronaryArteryBypassSurgery",
        },
        { name: "Head Trauma", value: "headTrauma" },
        { name: "Angioplasty", value: "angioplasty" },
        { name: "BMT", value: "bmt" },
        { name: "Operable Cancers", value: "operableCancers" },
        { name: "Early-Stage Cancers", value: "earlyStageCancers" },
        { name: "Heart Valve Surgery", value: "heartValveSurgery" },
        { name: "Pediatric Cancers", value: "pediatricCancers" },
        { name: "Neurosurgeries", value: "neurosurgeries" },
        { name: "RTA", value: "rta" },
        { name: "Brain Surgery", value: "brainSurgery" },
      ];
    } else {
      this.treatmentSubtypeOptions = [{ name: "", value: "" }];
      this.claimForm.controls["treatmentSubtype"].disabled;
    }
  }
  getStates() {
    this.registrationService.getStates().subscribe((res: any) => {
      this.states = res;
    });
  }
  onStateSelectionChange(event: any) {
    if (event.value) {
      if (event.value.name) {
        this.selectedState = event.value.name;
      }
      if (event.value.id) {
        this.registrationService
          .getCityByState(event.value.id)
          .subscribe((res: any) => {
            this.cities = res;
          });
      }
    }
  }
  checkValidity(){
    if (this.claimForm.invalid) {
      // // Loop through all form controls
      // for (const controlName in this.claimForm.controls) {
      //   if (this.claimForm.controls.hasOwnProperty(controlName)) {
      //     const control = this.claimForm.controls[controlName];
          
      //     if (control.invalid) {
      //       console.log(`${controlName} is invalid`);
      //     }
      //   }
      // }
      return true
    } else {
      // console.log('Form is valid, proceeding with submission');
      // Handle form submission
      return false
    }
        
  }
}
